import { gql } from '@apollo/client';
import { Cooperative } from 'cooperatives/models/cooperative';

export interface CooperativeCreateMutationInput {
  cooperativeHeadquarterId: number | null;
  cooperativeSubscriptionCostCents: number;
  cooperativeLegalName: string;
  cooperativeDocumentId: string;
  cooperativeAddressPostalCode: number;
  cooperativeAddressState: string;
  cooperativeAddressCity: string;
  cooperativeAddressStreet: string;
  cooperativeAddressDistrict: string;
  cooperativeAddressComplement: string | null;
  financialAccountId: number | null;
}

export interface CooperativeCreateMutationVariables {
  cooperativeCreateInput: CooperativeCreateMutationInput;
}

export interface CooperativeCreated {
  cooperativeCreate: Cooperative;
}

export const COOPERATIVE_CREATE_MUTATION = gql`
  mutation cooperativeCreate($cooperativeCreateInput: CooperativeCreateInput!) {
    cooperativeCreate(input: $cooperativeCreateInput) {
      id
      cooperativeLegalName
      cooperativeAddressState
      cooperativeAddressDistrict
      cooperativeSubscriptionCostCents
      cooperativeDocumentId
      cooperativeDeletedAt
      cooperativeHeadquarter {
        cooperativeLegalName
      }
      financialAccount {
        id
        financialAccountLegalName
      }
    }
  }
`;
